import React from 'react';
import GoldReportsPage from "@/modules/merchant/components/goldReports";
import Layout from "@/modules/merchant/layout/main";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ContentLayout from "@/modules/merchant/layout/contentLayout";

const GoldReports = () =>{
    return (
        <Layout>
            <ContentLayout icon={<AccountBalanceWalletOutlinedIcon />} title="تراکنش های خرید طلا" isContainerFluid>
                <GoldReportsPage/>
            </ContentLayout>
        </Layout>
    )
}

export default GoldReports;